import React, {useContext, useState} from 'react';
import {Card} from "../../../../../../components/card/card.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {IndividualContext} from "../../individual-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const Encounters = () => {
    const navigate = navigateHook();
    const {individualInfo} = useContext(IndividualContext)

    const [columnDefs] = useState([
        {headerName: "Abordado por", field: "userNameWar"},
        {headerName: "D/H inicial", field: "dtStart", valueFormatter: ({value}) => projectUtils.formatDate(value), width: 130},
        {headerName: "Observação", field: "observation", flex: 1},
    ]);

    const onRowClicked = ({data}) => {
        navigate(`/encounter/form/${data.id}`, true);
    }

    return (
        <Card>
            <Card.Header className={"gap-2"}>
                <Card.Title>
                    Abordagens
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className={"aggrid-row-pointer h-[calc(100vh-185px)]"}>
                    <AgGridReact
                        rowData={individualInfo?.encounters}
                        columnDefs={columnDefs}
                        animateRows={false}
                        suppressCellFocus={true}
                        gridOptions={{localeText: aggridUtils.localization()}}
                        theme={aggridUtils.generalTheme()}
                        onRowClicked={onRowClicked}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default Encounters;